function getMultiSelectSelector(id) {
  return '[for="multiselect-' + id + '"]';
}

jQuery(document).ready(function($) {

  /*
   * Event card level filter toggle
   */

  window.onLvlSpanClick = function (e) {
    e.preventDefault();
    var termId = parseInt(e.target.dataset.termId);
    if (!isNaN(termId)) {
      var label = document.querySelector('[for="multiselect-' + termId + '"]');
      if (label) {
        label.click();
      }
    }
  }
});